import React from "react";

const Safepal = () => {
  return <img src="./images/safepal.png" alt="safepal" className="sm:w-10 w-6 sm:h-10 h-6" />;
};

export default Safepal;
